// import css from "./popUp.module.css";

// export default function MainPopForH() {
//   return (
//     <div className={css.mainPopWrap}>
//       <p className={css.mainPopP}>
//         Ми називаємося "Час майстрів", бо впевнені: стрімкий розвиток
//         технологій, зокрема робототехніки, незабаром приведе до того, що
//         основною сферою діяльності людини стане творчість. Та щоб створити щось
//         дійсно вартісне, треба бути майстром своєї справи. Наша місія —
//         допомогати дітям зростати до рівня майстра."
//       </p>
//     </div>
//   );
// }
// src/components/MainPopForH.jsx
import React from "react";
import css from "./popUp.module.css";
import { db } from "../../firebase"; // підкоригуй шлях під свій
import { doc, onSnapshot } from "firebase/firestore";

// Документ для цього попапа
const DOC_ID = "mission_chas_maistriv"; // popups/mission_chas_maistriv

export default function MainPopForH() {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      setHtml(snap.exists() ? snap.data()?.contentHtml || "" : "");
    });
    return () => unsub();
  }, []);

  return (
    <div className={css.mainPopWrap}>
      <div
        className={`${css.mainPopP} ${css.ubuntuFont}`}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
}
